import React from "react";
import { useGetLocalText } from "../../utils";
import translationText from "../../translation.js";

function StateLeadership() {
  const { title: ministerSectionTitle } = useGetLocalText(translationText.ministerSectionTitle, [
    "title",
  ]);

  const { title: minister1Name } = useGetLocalText(translationText.minister1Name, [
    "title",
  ]);

  const { title: minister1Designation } = useGetLocalText(translationText.minister1Designation, [
    "title",
  ]);

  const { title: minister2Name } = useGetLocalText(translationText.minister2Name, [
    "title",
  ]);

  const { title: minister2Designation } = useGetLocalText(translationText.minister2Designation, [
    "title",
  ]);

  const { title: minister3Name } = useGetLocalText(translationText.minister3Name, [
    "title",
  ]);

  const { title: minister3Designation } = useGetLocalText(translationText.minister3Designation, [
    "title",
  ]);

  const { title: minister4Name } = useGetLocalText(translationText.minister4Name, [
    "title",
  ]);

  const { title: minister4Designation } = useGetLocalText(translationText.minister4Designation, [
    "title",
  ]);

  const { title: minister5Name } = useGetLocalText(translationText.minister5Name, [
    "title",
  ]);

  const { title: minister5Designation } = useGetLocalText(translationText.minister5Designation, [
    "title",
  ]);

  const { title: minister6Name } = useGetLocalText(translationText.minister6Name, [
    "title",
  ]);

  const { title: minister6Designation } = useGetLocalText(translationText.minister6Designation, [
    "title",
  ]);

  const { title: minister7Name } = useGetLocalText(translationText.minister7Name, [
    "title",
  ]);

  const { title: minister7Designation } = useGetLocalText(translationText.minister7Designation, [
    "title",
  ]);
  return (
    <section className="w-100 mt-2">
      <div>
        <h2 className="text-center mb-5" style={{ fontSize: '2.5rem', fontWeight: '500' }}>
          {ministerSectionTitle}
        </h2>
      </div>
      <div className="d-flex flex-column align-items-center mx-auto" style={{ width: '70%' }}>
        {/* First row: 1 minister */}
        <div className="d-flex justify-content-center mb-4">
          <div
            className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
            style={{ 
              borderRadius: '24px', 
              border: '2px solid #faa652',
              minHeight: '320px',
              overflow: 'hidden',
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
              maxWidth: '300px'
            }}
          >
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              <img
                src='/images/ministers/DevendraFadanvis.jpeg'
                alt={minister1Name}
                className="w-100 h-100"
                style={{ objectFit: 'cover', border: '1px solid white' }}
              />
            </div>
            <div 
              className="position-absolute text-end text-white d-flex flex-column"
              style={{ 
                backgroundColor: '#faa652',
                borderRadius: '22px 0 22px 0px',
                paddingLeft: '0.75rem',
                paddingRight: '0.25rem',
                paddingTop: '1rem',
                paddingBottom: '1rem',
                bottom: '0',
                right: '0'
              }}
            >
              <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                {minister1Name}
              </h3>
              <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                {minister1Designation}
              </p>
            </div>
          </div>
        </div>

         {/* Second row: 2 ministers */}
         <div className="row justify-content-center mb-4">
           <div className="col-12 col-md-6 d-flex justify-content-center mb-3">
             <div
               className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
               style={{ 
                 borderRadius: '24px', 
                 border: '2px solid #faa652',
                 minHeight: '320px',
                 overflow: 'hidden',
                 boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                 maxWidth: '300px'
               }}
             >
               <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                 <img
                   src='/images/ministers/DCM.jpg'
                   alt={minister2Name}
                   className="w-100 h-100"
                   style={{ objectFit: 'cover', border: '1px solid white' }}
                 />
               </div>
               <div 
                 className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                 style={{ 
                   backgroundColor: '#faa652',
                   borderRadius: '22px 0 22px 0px',
                   paddingLeft: '0.75rem',
                   paddingRight: '0.25rem',
                   paddingTop: '1rem',
                   paddingBottom: '1rem',
                bottom: '0',
                right: '0'
                 }}
               >
                 <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                   {minister2Name}
                 </h3>
                 <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                   {minister2Designation}
                 </p>
               </div>
             </div>
           </div>

           <div className="col-12 col-md-6 d-flex justify-content-center mb-3">
             <div
               className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
               style={{ 
                 borderRadius: '24px', 
                 border: '2px solid #faa652',
                 minHeight: '320px',
                 overflow: 'hidden',
                 boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                 maxWidth: '300px'
               }}
             >
               <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                 <img
                   src='/images/ministers/DCM_new.jpg'
                   alt={minister3Name}
                   className="w-100 h-100"
                   style={{ objectFit: 'cover', border: '1px solid white' }}
                 />
               </div>
               <div 
                 className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                 style={{ 
                   backgroundColor: '#faa652',
                   borderRadius: '22px 0 22px 0px',
                   paddingLeft: '0.75rem',
                   paddingRight: '0.25rem',
                   paddingTop: '1rem',
                   paddingBottom: '1rem',
                   bottom: '0',
                   right: '0'
                 }}
               >
                 <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                   {minister3Name}
                 </h3>
                 <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                   {minister3Designation}
                 </p>
               </div>
             </div>
           </div>
         </div>

          {/* Third row: remaining ministers */}
           <div className="row justify-content-center">
             <div className="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-3">
               <div
                 className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
                 style={{ 
                   borderRadius: '24px', 
                   border: '2px solid #faa652',
                   minHeight: '320px',
                   overflow: 'hidden',
                   boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
                 }}
               >
                 <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
                   <img
                     src='/images/ministers/pankajBhoyar.png'
                     alt={minister4Name}
                     className="w-100 h-100"
                     style={{ objectFit: 'cover', border: '1px solid white' }}
                   />
                 </div>
                 <div 
                   className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                   style={{ 
                     backgroundColor: '#faa652',
                     borderRadius: '22px 0 22px 0px',
                     paddingLeft: '0.75rem',
                     paddingRight: '0.25rem',
                     paddingTop: '1rem',
                     paddingBottom: '1rem',
                     bottom: '0',
                     right: '0'
                   }}
                 >
                   <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                     {minister4Name}
                   </h3>
                   <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                     {minister4Designation}
                   </p>
                 </div>
               </div>
               </div>

               <div className="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-3">
               <div
                 className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
                 style={{ 
                   borderRadius: '24px', 
                   border: '2px solid #faa652',
                   minHeight: '320px',
                   overflow: 'hidden',
                   boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
                 }}
               >
                 <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
                   <img
                     src='/images/ministers/Yogesh.jpg'
                     alt={minister5Name}
                     className="w-100 h-100"
                     style={{ objectFit: 'cover', border: '1px solid white' }}
                   />
                 </div>
                 <div 
                   className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                   style={{ 
                     backgroundColor: '#faa652',
                     borderRadius: '22px 0 22px 0px',
                     paddingLeft: '0.75rem',
                     paddingRight: '0.25rem',
                     paddingTop: '1rem',
                     paddingBottom: '1rem',
                     bottom: '0',
                     right: '0'
                   }}
                 >
                   <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                     {minister5Name}
                   </h3>
                   <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                     {minister5Designation}
                   </p>
                 </div>
               </div>
               </div>

               <div className="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-3">
               <div
                 className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
                 style={{ 
                   borderRadius: '24px', 
                   border: '2px solid #faa652',
                   minHeight: '320px',
                   overflow: 'hidden',
                   boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
                 }}
               >
                 <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
                   <img
                     src='/images/ministers/ACS_new.jpg'
                     alt={minister6Name}
                     className="w-100 h-100"
                     style={{ objectFit: 'cover', border: '1px solid white' }}
                   />
                 </div>
                 <div 
                   className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                   style={{ 
                     backgroundColor: '#faa652',
                     borderRadius: '22px 0 22px 0px',
                     paddingLeft: '0.75rem',
                     paddingRight: '0.25rem',
                     paddingTop: '1rem',
                     paddingBottom: '1rem',
                     bottom: '0',
                     right: '0'
                   }}
                 >
                   <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                     {minister6Name}
                   </h3>
                   <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                     {minister6Designation}
                   </p>
                 </div>
               </div>
               </div>

               <div className="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-3">
               <div
                 className="position-relative bg-white d-flex flex-column align-items-center p-0 w-100"
                 style={{ 
                   borderRadius: '24px', 
                   border: '2px solid #faa652',
                   minHeight: '320px',
                   overflow: 'hidden',
                   boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
                 }}
               >
                 <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white">
                   <img
                     src='/images/ministers/Shri-Sadanand-Date.jpg'
                     alt={minister7Name}
                     className="w-100 h-100"
                     style={{ objectFit: 'cover', border: '1px solid white' }}
                   />
                 </div>
                 <div 
                   className="position-absolute bottom-0 end-0 text-end text-white d-flex flex-column"
                   style={{ 
                     backgroundColor: '#faa652',
                     borderRadius: '22px 0 22px 0px',
                     paddingLeft: '0.75rem',
                     paddingRight: '0.25rem',
                     paddingTop: '1rem',
                     paddingBottom: '1rem',
                     bottom: '0',
                     right: '0'
                   }}
                 >
                   <h3 className="text-white mb-1" style={{ fontSize: '1.1rem', fontWeight: '600' }}>
                     {minister7Name}
                   </h3>
                   <p className="text-white mb-0" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                     {minister7Designation}
                   </p>
                 </div>
               </div>
             </div>
           </div>
      </div>
    </section>
  );
}

export default StateLeadership;
